/* eslint-disable max-len */
const Icon = (color) => {
  return `<?xml version="1.0" encoding="UTF-8"?> <svg width="44" height="60" viewBox="0 0 44 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_31_1463)">
<ellipse opacity="0.72" cx="22" cy="48" rx="12" ry="4" fill="${color}"/>
<g filter="url(#filter1_d_31_1463)">
<mask id="path-2-outside-1_31_1463" maskUnits="userSpaceOnUse" x="4" y="2" width="36" height="46" fill="black">
<rect fill="white" x="4" y="2" width="36" height="46"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 4C7.79086 4 6 5.79086 6 8V32C6 34.2091 7.79086 36 10 36H17.3812L22 44L26.6188 36H34C36.2091 36 38 34.2091 38 32V8C38 5.79086 36.2091 4 34 4H10Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 4C7.79086 4 6 5.79086 6 8V32C6 34.2091 7.79086 36 10 36H17.3812L22 44L26.6188 36H34C36.2091 36 38 34.2091 38 32V8C38 5.79086 36.2091 4 34 4H10Z" fill="${color}"/>
<path d="M17.3812 36L19.1132 35L18.5359 34H17.3812V36ZM22 44L20.2679 45L22 48L23.732 45L22 44ZM26.6188 36V34H25.4641L24.8868 35L26.6188 36ZM8 8C8 6.89543 8.89543 6 10 6V2C6.68629 2 4 4.68629 4 8H8ZM8 32V8H4V32H8ZM10 34C8.89543 34 8 33.1046 8 32H4C4 35.3137 6.68629 38 10 38V34ZM17.3812 34H10V38H17.3812V34ZM23.732 43L19.1132 35L15.6491 37L20.2679 45L23.732 43ZM24.8868 35L20.2679 43L23.732 45L28.3509 37L24.8868 35ZM34 34H26.6188V38H34V34ZM36 32C36 33.1046 35.1046 34 34 34V38C37.3137 38 40 35.3137 40 32H36ZM36 8V32H40V8H36ZM34 6C35.1046 6 36 6.89543 36 8H40C40 4.68629 37.3137 2 34 2V6ZM10 6H34V2H10V6Z" fill="white" mask="url(#path-2-outside-1_31_1463)"/>
</g>
<rect x="10" y="8" width="24" height="24" rx="2" fill="white"/>
<circle cx="22" cy="20" r="4" fill="${color}"/>
</g>
<defs>
<filter id="filter0_d_31_1463" x="0" y="2" width="44" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_31_1463"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_31_1463" result="shape"/>
</filter>
<filter id="filter1_d_31_1463" x="2" y="0" width="40" height="50" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_31_1463"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_31_1463" result="shape"/>
</filter>
</defs>
</svg>`;
};
export default Icon;
